import { IAircraft } from "@vmosolutions/oc-interfaces";

export const sortAircraftList = (aircraft: IAircraft[]): any => {
  if (aircraft.length > 0) {
    return aircraft.sort((a, b) => +b.isActive - +a.isActive);
  } else {
    return [];
  }
};

export const getLabel = (aircraftListItem: IAircraft): string => {
  const fullLabel: string[] = [];

  aircraftListItem?.identityDisplayOrder?.forEach((labelPart: string) => {
    // Handle nested properties (e.g., "aircraftType.title")
    const value = labelPart.split(".").reduce((obj: any, key: string) => {
      return obj?.[key];
    }, aircraftListItem);

    if (value != null && value !== "") {
      fullLabel.push(String(value));
    }
  });
  return fullLabel.join(" - ");
};
